import React from "react";
import './content_frame_styles.scss';

const ContentFrame = ({children}) => {
    return <div className="w-full relative rounded-3xl flex flex-col" id="content-frame">{children}</div>
}

export default ContentFrame;
